module.exports = __webpack_public_path__ + "static/media/0302pac-collab.e957ba9b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Media/0302pac-collab.jpg
// module id = 394
// module chunks = 0